var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Kiểm tra nhận diện AI : " + _vm.name,
        visible: _vm.dialogVisible,
        width: "80%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        "custom-class": "sk-dialog",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "sk-dialog-content" }, [
        _c(
          "div",
          { staticClass: "sk-panel", staticStyle: { "margin-bottom": "20px" } },
          [
            _c("div", { staticClass: "sk-panel-head" }, [
              _c("div", { staticClass: "sk-panel-icon" }, [
                _c("i", { staticClass: "el-icon-cpu" }),
              ]),
              _c("div", [
                _c("p", { staticClass: "sk-panel-title" }, [
                  _vm._v("Lịch sử nhận diện từ Camera AI"),
                ]),
                _c("p", { staticClass: "sk-panel-subtitle" }, [
                  _vm._v(
                    "\n            Chi tiết các lượt quét nhận diện, mốc thời gian và thiết bị ghi nhận của: "
                  ),
                  _c("strong", [_vm._v(_vm._s(_vm.name))]),
                ]),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "table-wrapper" },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticClass: "sk-table",
                attrs: {
                  "highlight-current-row": "",
                  "empty-text": _vm.textTable,
                  data: _vm.responseList,
                  "cell-style": _vm.tableRowStyle,
                  "header-cell-style": _vm.tableHeaderColor,
                  "max-height": _vm.$tableMaxHeight,
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: "STT",
                    width: "60",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "Tên", "min-width": "190" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "employeeNo",
                    label: "Mã",
                    "min-width": "100",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "nameEvent",
                    label: "Sử dụng",
                    "min-width": "120",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "time",
                    label: "Thời gian",
                    "min-width": "120",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "nameDevice",
                    label: "Thiết bị",
                    "min-width": "300",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "sk-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialog()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }